import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';
import zh from './locales/zh.json';
import de from './locales/de.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import uk from './locales/uk.json';

// Real, accurate primary language per theater/country - not a generic
// pan-region guess. AFRICA maps to Nigeria specifically (see app/Nolly.js -
// "Nolly" = Nollywood, the Nigerian film industry), whose official/media
// language is English.
export const COUNTRY_LANGUAGE = {
  '': 'en',
  USA: 'en',
  UK: 'en',
  AUSTRALIA: 'en',
  AFRICA: 'en',
  INDIA: 'hi',
  CHINA: 'zh',
  GERMANY: 'de',
  JAPAN: 'ja',
  KOREA: 'ko',
  MEXICO: 'es',
  FRANCE: 'fr',
  UKRAINE: 'uk',
  SPAIN: 'es',
  ITALY: 'en',
  PORTUGAL: 'en',
  NETHERLANDS: 'en',
  BELGIUM: 'en',
  SWITZERLAND: 'de',
  AUSTRIA: 'de',
  SWEDEN: 'en',
  NORWAY: 'en',
  DENMARK: 'en',
  FINLAND: 'en',
  POLAND: 'en',
  CZECHIA: 'en',
  SLOVAKIA: 'en',
  HUNGARY: 'en',
  ROMANIA: 'en',
  BULGARIA: 'en',
  GREECE: 'en',
  CROATIA: 'en',
  SERBIA: 'en',
  SLOVENIA: 'en',
  BOSNIA: 'en',
  ALBANIA: 'en',
  MACEDONIA: 'en',
  MONTENEGRO: 'en',
  KOSOVO: 'en',
  IRELAND: 'en',
  ICELAND: 'en',
  ESTONIA: 'en',
  LATVIA: 'en',
  LITHUANIA: 'en',
  LUXEMBOURG: 'fr',
  MALTA: 'en',
  CYPRUS: 'en',
  MOLDOVA: 'en',
  BELARUS: 'en',
  GEORGIA: 'en',
  ARMENIA: 'en',
  AZERBAIJAN: 'en',
  ANDORRA: 'en',
  MONACO: 'fr',
  SANMARINO: 'en',
  LIECHTENSTEIN: 'de',
  VATICAN: 'en',
  RUSSIA: 'en',
  INDONESIA: 'en',
  PAKISTAN: 'en',
  BANGLADESH: 'en',
  PHILIPPINES: 'en',
  VIETNAM: 'en',
  THAILAND: 'en',
  MYANMAR: 'en',
  MALAYSIA: 'en',
  NEPAL: 'en',
  SRILANKA: 'en',
  CAMBODIA: 'en',
  LAOS: 'en',
  MONGOLIA: 'en',
  BHUTAN: 'en',
  SINGAPORE: 'en',
  BRUNEI: 'en',
  TIMORLESTE: 'en',
  MALDIVES: 'en',
  KAZAKHSTAN: 'en',
  UZBEKISTAN: 'en',
  TURKMENISTAN: 'en',
  TAJIKISTAN: 'en',
  KYRGYZSTAN: 'en',
  AFGHANISTAN: 'en',
  IRAN: 'en',
  IRAQ: 'en',
  SAUDIARABIA: 'en',
  UAE: 'en',
  QATAR: 'en',
  KUWAIT: 'en',
  BAHRAIN: 'en',
  OMAN: 'en',
  JORDAN: 'en',
  LEBANON: 'en',
  ISRAEL: 'en',
  PALESTINE: 'en',
  SYRIA: 'en',
  YEMEN: 'en',
  TURKEY: 'en',
  TAIWAN: 'zh',
  HONGKONG: 'zh',
  MACAU: 'zh',
  NIGERIA: 'en',
  EGYPT: 'en',
  SOUTHAFRICA: 'en',
  KENYA: 'en',
  ETHIOPIA: 'en',
  GHANA: 'en',
  TANZANIA: 'en',
  UGANDA: 'en',
  ALGERIA: 'fr',
  MOROCCO: 'fr',
  TUNISIA: 'fr',
  LIBYA: 'en',
  SUDAN: 'en',
  SENEGAL: 'fr',
  IVORYCOAST: 'fr',
  CAMEROON: 'fr',
  MALI: 'fr',
  BURKINAFASO: 'fr',
  NIGER: 'fr',
  CHAD: 'fr',
  GUINEA: 'fr',
  BENIN: 'fr',
  TOGO: 'fr',
  RWANDA: 'fr',
  BURUNDI: 'fr',
  SOMALIA: 'en',
  ZAMBIA: 'en',
  ZIMBABWE: 'en',
  MOZAMBIQUE: 'en',
  ANGOLA: 'en',
  NAMIBIA: 'en',
  BOTSWANA: 'en',
  MALAWI: 'en',
  MADAGASCAR: 'fr',
  CONGODR: 'fr',
  CONGO: 'fr',
  GABON: 'fr',
  SIERRALEONE: 'en',
  LIBERIA: 'en',
  GAMBIA: 'en',
  ERITREA: 'en',
  DJIBOUTI: 'fr',
  SOUTHSUDAN: 'en',
  EQUATORIALGUINEA: 'es',
  MAURITANIA: 'en',
  LESOTHO: 'en',
  ESWATINI: 'en',
  COMOROS: 'en',
  CAPEVERDE: 'en',
  MAURITIUS: 'en',
  SEYCHELLES: 'en',
  GUINEABISSAU: 'en',
  CENTRALAFRICANREPUBLIC: 'fr',
  SAOTOME: 'en',
  CANADA: 'en',
  GUATEMALA: 'es',
  CUBA: 'es',
  HAITI: 'fr',
  DOMINICANREPUBLIC: 'es',
  HONDURAS: 'es',
  ELSALVADOR: 'es',
  NICARAGUA: 'es',
  COSTARICA: 'es',
  PANAMA: 'es',
  JAMAICA: 'en',
  TRINIDAD: 'en',
  BAHAMAS: 'en',
  BARBADOS: 'en',
  BELIZE: 'en',
  ANTIGUA: 'en',
  SAINTLUCIA: 'en',
  SAINTVINCENT: 'en',
  GRENADA: 'en',
  SAINTKITTS: 'en',
  DOMINICA: 'en',
  BRAZIL: 'en',
  ARGENTINA: 'es',
  COLOMBIA: 'es',
  PERU: 'es',
  VENEZUELA: 'es',
  CHILE: 'es',
  ECUADOR: 'es',
  BOLIVIA: 'es',
  PARAGUAY: 'es',
  URUGUAY: 'es',
  GUYANA: 'en',
  SURINAME: 'en',
  NEWZEALAND: 'en',
  FIJI: 'en',
  PAPUANEWGUINEA: 'en',
  SOLOMONISLANDS: 'en',
  VANUATU: 'en',
  SAMOA: 'en',
  TONGA: 'en',
  KIRIBATI: 'en',
  MICRONESIA: 'en',
  PALAU: 'en',
  MARSHALLISLANDS: 'en',
  NAURU: 'en',
  TUVALU: 'en',
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    zh: { translation: zh },
    de: { translation: de },
    ja: { translation: ja },
    ko: { translation: ko },
    es: { translation: es },
    fr: { translation: fr },
    uk: { translation: uk },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
